<template>
    <div class="faq p-1 md:p-2" :class="{ 'open' : open }">

        <dt>

            <button aria-label="Open and close accordion" class="bg-grey-3 inline-block expand-box" @click.prevent="toggleAnswer">
                <svg v-if="!open" class="fill-current h-12 w-12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                <svg v-else class="fill-current h-12 w-12" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M-1-1h582v402H-1z"/><g><path stroke="null" d="M10.707 7.293L10 6.586l-5.657 5.657 1.414 1.414L10 9.415l4.243 4.242 1.414-1.414-4.95-4.95z"/></g></svg>
            </button>

            <a class="inline-block capitalize font-500 text-2 text-black" href="#" @click.prevent="toggleAnswer" @keypress.enter="toggleAnswer" @keypress.space="toggleAnswer">
                <slot></slot>
            </a>

        </dt>

        <dd v-if="open" class="mt-2 leading-normal text-grey-2">
            <slot name="answer"></slot>
        </dd>

    </div>
</template>

<script>
    export default {

        name: 'Collapsable',

        props: ['opened'],

        data() {
            return {
                open: this.opened,
            }
        },

        methods: {

            toggleAnswer() {
                this.open = !this.open;
            },

        },

    }
</script>

<style scoped>
    .open {
        box-shadow: 0px 0px 17px 2px rgba(0, 0, 0, 0.3);
        margin-bottom: 30px;
    }

    .expand-box {
        width: 30px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        margin-right: 20px;
    }

    .expand-box svg {
        transform: translateY(1px);
    }
</style>



// WEBPACK FOOTER //
// web/app/themes/giles/resources/js/components/Collapsable.vue